//import 'bulma/css/bulma.min.css';
import './style/arc.css';

import React, { Suspense } from 'react'
import BeatLoader from "react-spinners/BeatLoader";


import Configurator from './configurator/Configurator'

export default function App() {
  
  var configuration = {
    base_url: 'https://ar-configurator-3d.herokuapp.com/models',
    model: '/step.glb',
    //scale: 2.0,
    base_price: 1200,
    base_camera: { fov: 50, position:[4, 2, 5] },
    orbit: {
      target: [0, 0, 0]
    },
    variants: [
      {
        id: 'paint',
        label: 'Lak',
        camera: [],
        options: [
          {
            id: 'black',
            label: 'Zwart',
            color: '#000000',
            material: {
              paint: {
                color: '#000000',
                map: '/paint-baked-ao.jpg'
              }
            },
          },
          {
            id: 'white',
            label: 'Wit',
            color: '#FFFAF0',
            color_contrast: '#333',
            material: {
              paint: {
                color: '#FFFAF0',
                map: '/paint-baked-ao.jpg',
                roughness: 0.6
              }
            },
          },
          {
            id: 'darkgeen',
            label: 'Donkergroen',
            color: '#4D5D53',
            material: {
              paint: {
                color: '#4D5D53',
                map: '/paint-baked-ao.jpg'
              }
            },
            extra_price: 80
          },
          {
            id: 'blue',
            label: 'Blauw',
            color: '#364F82',
            material: {
              paint: {
                color: '#364F82',
                map: '/paint-baked-ao.jpg'
              }
            },
            extra_price: 80
          },
          {
            id: 'orange',
            label: 'Oranje',
            color: '#EB8624',
            material: {
              paint: {
                color: '#EB8624',
                map: '/paint-baked-ao.jpg',
                roughness: .6
              }
            },
            extra_price: 130
          }
        ]
      },
      {
        id: 'tyres',
        label: 'Banden',
        camera: [],
        options: [
          {
            id: 'black',
            label: 'Zwart',
            color: '#111111',
            material: {
              rubber: {
                color: '#111111'
              }
            }
          },
          {
            id: 'brown',
            label: 'Bruin',
            color: '#8b4e39',
            extra_price: 50,
            material: {
              rubber: {
                color: '#8b4e39',
                map: "/paint-baked-ao.jpg"
              }
            }
          },
          {
            id: 'offwhite',
            label: 'Donker wit',
            color: '#D9C278',
            color_contrast: '#333',
            material: {
              rubber: {
                color: '#D9C278'
              }
            },
            extra_price: 50
          }
        ]
      }
    ],
    cameras: [],
    environment_label: 'Omgeving',
    environments: [
      {
        id: 'city',
        label:'City',
        hdri: 'environments/oldcity-blur-1k.hdr',
        thumbnail: "environments/thumbnails/50x50-thumb-old-city.jpg"
      },
      {
        id: 'paul-lobe-haus',
        label:'Urban',
        hdri: 'environments/paul-lobe-haus-blur-1k.hdr',
        thumbnail: "environments/thumbnails/50x50-thumb-paul-lobe-haus.jpg"
      },
      {
        id: 'etnies-park-center',
        label:'Urban',
        hdri: 'environments/etnies-park-center-blur-1k.hdr',
        thumbnail: "environments/thumbnails/50x50-thumb-etnies-park-center.jpg"
      },
      {
        id: 'groenewijk',
        label:'Urban',
        hdri: 'environments/groenewijk-blur-1k.hdr',
        thumbnail: "environments/thumbnails/50x50-thumb-groenewijk.jpg"
      }
    ],
    ui: {
      title: '',//'Configureer je step',
      buy_button: "Bestel",
      ar_button: '',
      features: {
        option_price_diffs: true,
        option_price_amounts: false
      }
     }
  };

  var configuration2 = {
    model: '/models/pergola.gltf',
    base_url:'',
    base_price: 1200,
  
    orbit: {
      target: [0, 13, 0],
      minDistance: 80,
      maxDistance: 120,
      maxPolarAngle: Math.PI/2,
    },

    variants: [
      {
        id: 'paint',
        label: 'Lak',
        camera: [],
        options: [
          {
            id: 'black',
            label: 'Zwart',
            color: '#000000',
            material: {
              grey: {
                color: '#000000',
              }
            },
          },
          {
            id: 'white',
            label: 'Wit',
            color: '#FFFAF0',
            color_contrast: '#333',
            material: {
              grey: {
                color: '#FFFAF0',
                roughness: 0.6
              }
            },
          },
          {
            id: 'darkgeen',
            label: 'Donkergroen',
            color: '#4D5D53',
            material: {
              grey: {
                color: '#4D5D53',
              }
            },
            extra_price: 80
          },
          {
            id: 'blue',
            label: 'Blauw',
            color: '#364F82',
            material: {
              grey: {
                color: '#364F82',
              }
            },
            extra_price: 80
          },
          {
            id: 'orange',
            label: 'Oranje',
            color: '#EB8624',
            material: {
              grey: {
                color: '#EB8624',
                roughness: 0
              }
            },
            extra_price: 130
          }
        ]
      }
    ],
    base_camera: { fov: 30, position:[-100,-100,3] },
    scale: 1,
    cameras: [],
    environment_label: 'Omgeving',
    environments: [
      {
        id: 'city',
        label:'City',
        hdri: 'environments/oldcity-blur-1k.hdr',
        thumbnail: "environments/thumbnails/50x50-thumb-old-city.jpg"
      },
      {
        id: 'paul-lobe-haus',
        label:'Urban',
        hdri: 'environments/paul-lobe-haus-blur-1k.hdr',
        thumbnail: "environments/thumbnails/50x50-thumb-paul-lobe-haus.jpg"
      },
      {
        id: 'etnies-park-center',
        label:'Urban',
        hdri: 'environments/etnies-park-center-blur-1k.hdr',
        thumbnail: "environments/thumbnails/50x50-thumb-etnies-park-center.jpg"
      },
      {
        id: 'groenewijk',
        label:'Urban',
        hdri: 'environments/groenewijk-blur-1k.hdr',
        thumbnail: "environments/thumbnails/50x50-thumb-groenewijk.jpg"
      }
    ],
    ui: {
      title: '',//'Configureer je step',
      buy_button: "Bestel",
      ar_button: ''
     }
  };

  return (
    <Suspense fallback={
      <div style={{ minHeight: '100%', height:'100%', position: "fixed", top: "50%", left: "50%" }}>
        <BeatLoader color={'#14549A'} />
      </div>
    }>
      <Configurator configuration={configuration}/>
    </Suspense>    
  )
}
// 